/* AOF Ben's Recommendations — prev/next scroll for the product rail.
 *
 * Mirrors the rod-carousel pattern: the header chevrons scroll the row by
 * ~85% of the visible viewport per click. Buttons disable at each end and
 * re-evaluate on scroll, resize and load (so layout shifts from image
 * decode or font swap are handled). On desktop where all cards fit, both
 * buttons stay disabled. Touch users swipe natively.
 */
(function () {
  'use strict';

  function init(section) {
    var viewport = section.querySelector('[data-aof-rec-viewport]');
    if (!viewport) return;
    var row  = viewport.querySelector('[data-aof-rec-row]');
    var prev = section.querySelector('[data-aof-rec-prev]');
    var next = section.querySelector('[data-aof-rec-next]');
    if (!row || !prev || !next) return;

    function maxScroll() { return row.scrollWidth - row.clientWidth; }

    function updateState() {
      var max = maxScroll();
      if (max <= 1) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      prev.disabled = row.scrollLeft <= 4;
      next.disabled = row.scrollLeft >= max - 4;
    }

    function step(direction) {
      row.scrollBy({ left: direction * row.clientWidth * 0.85, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    row.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState);

    updateState();
    if (document.readyState !== 'complete') {
      window.addEventListener('load', updateState, { once: true });
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var sections = document.querySelectorAll('.section-aof-bens-recommendations');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
  });
})();
